import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../css/components/common/loadingSpinner.css';

function LoadingSpinner({
	isOnCtaButton = false,
	isOnLoginFormButton = false,
	isOnTextInput = false,
	isOnLoginFormTextInput = false,
	extraClassName = '',
	isBigbeat = false,
}) {
	let classNames = `${styles.spinner} ${styles[extraClassName]}`;

	if (isOnCtaButton) {
		classNames += ` ${styles.ctaButton}`;
	}

	if (isOnLoginFormButton) {
		classNames += ` ${styles.loginButton}`;
	}

	if (isOnTextInput) {
		classNames += ` ${styles.textInput}`;
	}

	if (isOnLoginFormTextInput) {
		classNames += ` ${styles.textInputLogin}`;
	}

	if (isBigbeat) {
		classNames += ` ${styles.bigbeat}`;
	}

	return(
		<span
			data-testid="loadingSpinner"
			className={classNames}
		/>
	);
}

export default LoadingSpinner;

LoadingSpinner.propTypes = {
	isOnCtaButton: PropTypes.bool,
	isOnLoginFormButton: PropTypes.bool,
	isOnTextInput: PropTypes.bool,
	isOnLoginFormTextInput: PropTypes.bool,
	extraClassName: PropTypes.string,
	isBigbeat: PropTypes.bool,
};
